export const getEnv = () => {
    const hostName = window.location.hostname;
    if (hostName.includes('.dev.') || hostName.includes('.adev.')) {
      return 'development';
    } else if (
      hostName.includes('.staging.') ||
      hostName.includes('.stg.') ||
      hostName.includes('.stg-east.')
    ) {
      return 'staging';
    } else if (
      hostName.includes('.prod.') ||
      hostName.includes('.prod-east.') ||
      hostName.includes('rovo-slack-onboarding.atlassian.com') ||
      hostName.includes('rovo-integrations.atlassian.com')
    ) {
      return 'production';
    } else if (hostName.includes('localhost')) {
      return 'local';
    } else {
      return 'staging';
    }
  };
  
  export const getIdentityUrl = () => {
    if (getEnv() === 'production') {
      return 'https://id.atlassian.com';
    }
  
    return 'https://id.stg.internal.atlassian.com';
  };
  
  export const handleLogin = () => {
    if (process.env['NODE_ENV'] !== 'local') {
      window.location.href = `${getIdentityUrl()}/login?continue=${window.location.href}`;
    }
  };
  
  export const handleLogout = () => {
    window.location.href = `${getIdentityUrl()}/logout?continue=${window.location.protocol}//${window.location.host}`;
  };
  
  export const handleSwitchAccountClick = () => {
    window.location.href = `${getIdentityUrl()}/login?prompt=select_account&continue=${window.location.protocol}//${
      window.location.host
    }`;
  };